import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { Notification, NotificationResponse } from "~types/notification.ts";

export const useMarkAsReadNotifications = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  return useMutation<NotificationResponse, Error>({
    mutationFn: async () => await request(`notifications/mark-as-read`, { method: "POST" }),
    onSuccess: (response: NotificationResponse) => {
      queryClient.setQueryData(["notifications"], (_?: Notification[]) => response.data || []);
      refetchUserUpdates();
    },
  });
};
